import axiosClient from "./axiosClient";
import { processParameters } from "./utils/utils";

export const getReviewsRankingData = (companyId, timePeriod, reputationOrderType = 'AVERAGE_SCORE_DESC', pageNumber = 0, pageSize = 5) => {
    const params = processParameters(
        [timePeriod.value, "timePeriod"],
        [reputationOrderType, "reputationOrderType"],
        [pageNumber, "pageNumber"],
        [pageSize, "pageSize"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.from : null, "from"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.to : null, "to"],
    );

    return axiosClient.get(`/dashboard-v2/reviews/company/${companyId}?${params}`);
}

export const getGlobalMetricsKpisByCompanyId = (companyId, timePeriod) => {
    const params = processParameters(
        [timePeriod.value, "period"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.from : null, "from"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.to : null, "to"]
    );
    return axiosClient.get(`/metrics/gbp/global/companies/${companyId}?${params}`);
}

export const getLocalSEOTableData = (companyId, pageNumber = 0, timePeriod, pageSize = 5, localSeoOrderType = 'AVERAGE_RANKING_DESC') => {
    const params = processParameters(
        [pageNumber, "page"],
        [timePeriod.value, "period"],
        [pageSize, "size"],
        [localSeoOrderType, "localSeoOrderType"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.from : null, "from"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.to : null, "to"],
    );
    return axiosClient.get(`/metrics/gbp/ranking/companies/${companyId}?${params}`);
}

export const getReviewsInsightsEvolutionGoogle = (storeId, timePeriod) => {
    const params = processParameters(
        [timePeriod.value, "intervalPeriod"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.from : null, "from"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.to : null, "to"],
        

    );
    return axiosClient.get(`/feedback/reviews/insights/evolution/google?storeId=${storeId}&${params}`);
}

export const getReviewsDataByStore = (storeId, timePeriod) => {
    const params = processParameters(
        [timePeriod.value, "timePeriod"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.from : null, "from"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.to : null, "to"],
        
    );
    return axiosClient.get(`/dashboard-v2/reviews/store/${storeId}?${params}`);
}

export const getLocalSeoStoreChartData = (socialLocationId, timePeriod = 'LAST_7_DAYS') => {
    const params = processParameters(
        [timePeriod.value, "timePeriod"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.from : null, "from"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.to : null, "to"]
    );
    return axiosClient.get(`/dashboard-v2/google-maps/location/${socialLocationId}/ranking-list-by-period?${params}`);
}

export const getGlobalMetricsKpisByStoreId = (storeId, timePeriod) => {
    const params = processParameters(
        [timePeriod.value, "period"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.from : null, "from"],
        [timePeriod.value === 'CUSTOM' ? timePeriod.to : null, "to"]
    );
    return axiosClient.get(`/metrics/gbp/global/stores/${storeId}?${params}`);
}

export const getActionablesSideBarData = (companyId, locale) => {
    const params = processParameters(
        [locale, "locale"]
    );
    return axiosClient.get(`/dashboard/actionables/companies/${companyId}?${params}`);
}

export const getActionablesSideBarDataByStoreId = (storeId, locale) => {
    const params = processParameters(
        [locale, "locale"]
    );
    return axiosClient.get(`/dashboard/actionables/stores/${storeId}?${params}`);
}


export const callbackActionable = (companyId, storeId, url) => {
    return axiosClient.post(url, {
        storeId: storeId,
        companyId: companyId
    });
}
 
export const getActiveStoresByCompanyId = (companyId) => {
    return axiosClient.get(`/companies/${companyId}/stores/active`);
}

export const startCompanyUsersDownloadProcessByStoreId = (storeId) => {
    return axiosClient.post(`/users/last-year-users/${storeId}`, {});
}

export const getCompanyUsersDownloadStatusByStoreId = (storeId) => {
    return axiosClient.get(`/users/last-year-users/${storeId}`);
}
 
export const getCompanyUsersDownloadCSVByStoreId = (storeId) => {
    return axiosClient.delete(`/users/last-year-users/csv/${storeId}`, {
        responseType: 'blob'
    });
}

export const getCompanyOptinStatusReviewLeaderboard = (companyId) => {
    return axiosClient.get(`/companies/${companyId}/review-leaderboard-optin`);
};


